<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('edit') }} {{ $t('offertypes') }}</div>
      <div>
        <router-link class="btn-blue" to="offer-types">{{ $t('offertypes') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                v-model="offerDetails.ot_offer_type"
                v-validate="{required: 'required', regex:/^[a-zA-Z0-9-% ]*$/}"
                placeholder="."
                type="text"
                name="ot_offer_type"
                id="ot_offer_type"
              />
              <label>{{ $t('offer') }} {{ $t('type') }}</label>
            </div>
            <Tooltip :title="$t('offernameoffertype')" />
          </div>
          <p class="error_message">
            <span
              v-if="submitted && errors.has('ot_offer_type')"
            >{{ errors.first('ot_offer_type') }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="selected.marketing_type.length > 0 ? 'shift-up' : '' "
            >{{ $t('marketing') }} {{ $t('type') }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown :text="selected.marketing_type" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(marketing_type, marketing_typeIndex) in marketing_types"
                  :key="marketing_typeIndex"
                  v-on:click="onSelectHandler('marketing_type',marketing_type)"
                  name="selectmarketingtype"
                  id="selectmarketingtype"
                >{{ marketing_type.mkt_title }}</b-dropdown-item>
              </b-dropdown>
              <Tooltip :title="$t('marketingtypeoffertype')" />
            </div>
            <p class="error_message">
              <span v-if="submitted && selected.marketing_type.length == 0">{{$t('marketTypemsg')}}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t('active') }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  unchecked-value="N"
                  value="Y"
                  v-model="offerDetails.ot_is_active"
                  name="check-button"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">{{ $t('update') }}</button>
          <!-- <button class="btn-blue">{{ $t('saveaddmore') }}</button>
          <button class="btn-black">{{ $t('reset') }}</button>-->
          <b-button
            @click.prevent.stop="onResetForm()"
            class="btn-outline-grey"
            variant="default"
            to="offer-types"
          >{{ $t('cancel') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import moment from "moment";
import { METHODS } from "http";
const selected = {
  marketing_type: "",
};

export default {
  data() {
    return {
      marketing_types: [],
      marketing_typesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_marketing_types",
        urlKey: "marketing_types",
      },
      selected: selected,
      submitted: false,
      items: [],
      offerDetails: {
        ot_offer_type: "",
        marketing_type_id: "",
        ot_is_active: "",
        ot_id: "",
      },
    };
  },
  beforeMount() {
    const { ot_id } = this.$route.query;
    // console.log("ot_id :", ot_id);
    if (ot_id) {
      this.getOfferDetails(ot_id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    getOfferDetails: function (ot_id) {
      MarketingService.getSingleOfferDetails({ ot_id }).then((response) => {
        const { data } = response;
        // console.log("data :", data);
        if (data.Records) {
          this.offerDetails = {
            ...this.offerDetails,
            ...data.Records[0],
          };
          this.getMarketingList(data.Records[0].marketing_type_id);
        }
      });
    },
    onResetForm: function () {
      (this.offerDetails.ot_offer_type = null),
        (this.selected.marketing_type = null);
    },
    // },
    getMarketingList: function (mkt_id) {
      this.marketing_types = [];
      let payload = {
        tableName: "ms_marketing_types",
        mkt_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.marketing_types = data.Records;
            if (mkt_id) {
              this.marketing_types.map((x) => {
                if (mkt_id === x.mkt_id) {
                  this.selected.marketing_type = x.mkt_title;
                  // console.log(
                  //   "this.selected.marketing_type :",
                  //   this.selected.marketing_type
                  // );
                  this.onSelectHandler("marketing_type", x);
                }
              });
            }
          } else {
            //  this.$toasted.show("5"+data.message);
          }
        })
        .catch(this._CatchError);
    },

    onSelectHandler: function (type, value) {
      if (type == "ot_offer_type") {
        this.offerDetails.ot_offer_type = value.ot_offer_type;
      } else if (type == "marketing_type") {
        // console.log("value :", value);
        this.selected.marketing_type_id = value.mkt_id;
        this.selected.marketing_type = value.mkt_title;
        // console.log(
        //   "this.selected.marketing_type :",
        //   this.selected.marketing_type
        // );
        this.offerDetails.marketing_type_id = value.mkt_id;
      }
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (this.selected.marketing_type.length == 0) {
            return;
          } else {
            MarketingService.editOfferType({ ...this.offerDetails })
              .then((response) => {
                const { data } = response;
                if (data.status) {
                  this.$toasted.show(data.message);

                  if (redirect) {
                    this.onResetForm(),
                      this.$router.push({
                        path: "/marketing/offer-types",
                      });
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError);
          }
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/OfferComponents/editOfferTypes.vue